import React from 'react';

import { replaceAll } from './../../../../../mol_function';

export default class FB_pixel extends React.Component {
  render() {
    let pixelJs =
      `
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);
    //t.async=!0;
    t.src=v;
    s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','//connect.facebook.net/en_US/fbevents.js');
    // Insert Your Facebook Pixel ID below. 
    fbq('init', '1300907099926580');

    fbq('init', '417368186590646'); //FB_MOLUNA_20211117_14

    fbq('track', 'PageView');
    
    fbq('track', 'ViewContent', {
      content_name: '` +
      this.props.body.title +
      `',
      content_category: '` +
      this.props.body.categorie +
      `',
      content_ids: ['` +
      this.props.body.productsId +
      `'],
      content_type: 'product',
      value: ` +
      this.replaceComa_Punkt(
        this.props.body.productPrice.substring(
          0,
          this.props.body.productPrice.length - 2,
        ),
      ) +
      `,
      currency: 'EUR'
     });
     `;
    return <script dangerouslySetInnerHTML={{ __html: pixelJs }} />;
  }
  replaceComa_Punkt(input) {
    return replaceAll(input, ',', '.');
  }
}
